import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

import NumberFormat from "react-number-format";
import { Save } from "lucide-react";

export const BankAccountForm = ({
  formData,
  catalogs,
  saveForm,
  handleUpdateForm,
  loading,
}) => {

  const controlled = formData.control_saldo ?? Boolean(formData.fecha_inicio_control);
  const missingOpening = formData.saldo_inicial == null || String(formData.saldo_inicial).trim() === '';

  const handleChange = ({ target }) => {
    handleUpdateForm({
      [target.name]: target.value,
    });
  };

  const handleChangeMonto = (value, targetName) => {
    handleUpdateForm({
      [targetName]: value.floatValue,
    });
  };

  const handleChangeStatus = ({ target }) => {
    handleUpdateForm({
      [target.name]: target.checked,
    });
  };

  const handleSave = async () => {
    await saveForm();
  };

  return (
    <div className="row p-dialog-form mt-2">
      <div className="col">
        <div className="flex items-center">
          <input
            className="ms-1 cursor-pointer"
            type="checkbox"
            name="estado"
            id="input_check_act"
            checked={formData.estado}
            onChange={handleChangeStatus}
          />
          <label
            htmlFor="input_check_act"
            className="text-sm ms-1 cursor-pointer"
          >
            {formData.estado === true ? "Activado" : "Desactivado"}
          </label>
        </div>

        <div className="row">
          <div className="col">
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label">Banco</InputLabel>
              <Select
                label="Banco"
                id="id_banco"
                name="id_banco"
                value={parseInt(formData.id_banco) || ""}
                onChange={handleChange}
                className="p-list-capitalize"
              >
                <MenuItem value="" key="">
                  Ninguno
                </MenuItem>
                {catalogs.bancos.map((item) => (
                  <MenuItem value={item.id} key={item.id}>
                    {item.nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label">
                Tipo de cuenta
              </InputLabel>
              <Select
                label="Tipo de cuenta"
                id="id_tipo_cuenta"
                name="id_tipo_cuenta"
                value={formData.id_tipo_cuenta || ""}
                onChange={handleChange}
                className="p-list-capitalize"
              >
                <MenuItem value="" key="">
                  Ninguno
                </MenuItem>
                {catalogs.tiposCuentas.map((item) => (
                  <MenuItem value={item.id} key={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <TextField
              label="N° de cuenta"
              name="numero"
              id="outlined-size-small"
              value={formData.numero || ""}
              size="small"
              fullWidth
              placeholder="Ingrese número cuenta"
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <TextField label="Descripción" name="nombre" value={formData.nombre || ''}
              size="small" fullWidth placeholder="Ej. Cuenta principal de operaciones" onChange={handleChange} />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label">Moneda</InputLabel>
              <Select
                label="Moneda"
                id="id_moneda"
                name="id_moneda"
                disabled={Boolean(formData.has_movements)}
                value={formData.id_moneda || ""}
                onChange={handleChange}
                className="p-list-capitalize"
              >
                <MenuItem value="" key="">
                  Ninguno
                </MenuItem>
                {catalogs.monedas.map((item) => (
                  <MenuItem value={item.id} key={item.id}>
                    {item.nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <label className="d-flex gap-2 align-items-center mb-2">
              <input type="checkbox" checked={controlled} onChange={event => {
                const enabled = event.target.checked;
                handleUpdateForm({
                  control_saldo: enabled,
                  fecha_inicio_control: null,
                  ...(enabled ? { saldo_inicial: undefined } : { saldo_inicial: 0 }),
                });
              }} />
              Habilitar control de saldo
            </label>
            <label className="block text-gray-600">Saldo de apertura verificado</label>
            <NumberFormat
              className={`text-end monto normal text-black`}
              value={formData.saldo_inicial ?? ""}
              disabled={!controlled}
              thousandSeparator={formData?.separacion_miles}
              decimalSeparator={formData?.separacion_decimales}
              prefix={`${formData?.simbolo} `}
              onValueChange={(values) =>
                handleChangeMonto(values, "saldo_inicial")
              }
              decimalScale={2}
              fixedDecimalScale
            />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <label className="block text-gray-600">Saldo registrado (calculado)</label>
            <NumberFormat
              className={`text-end monto normal text-black`}
              value={controlled ? (formData.id ? formData.saldo_actual : formData.saldo_inicial || 0) : 0}
              thousandSeparator={formData?.separacion_miles}
              decimalSeparator={formData?.separacion_decimales}
              prefix={`${formData?.simbolo} `}
              readOnly
              decimalScale={2}
              fixedDecimalScale
            />
            <small>Con el control habilitado, el saldo de apertura debe corresponder al inicio de la fecha indicada, antes de los cobros y pagos de ese día.</small>
          </div>
        </div>

        <div className="row mt-2">
          <div className="col">
            <label className="block text-gray-600" htmlFor="bank-control-date">Fecha de inicio de control</label>
            <input
              className="border p-1 px-2 rounded-md w-fit text-start"
              type="date"
              name="fecha_inicio_control"
              id="bank-control-date"
              required={controlled}
              disabled={!controlled}
              value={formData.fecha_inicio_control || ''}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="flex justify-end mt-2">
          <button
            className="btn flex items-center justify-center"
            onClick={handleSave}
            disabled={loading || (controlled && (!formData.fecha_inicio_control || missingOpening))}
          >
            <Save className="w-5 h-5 text-white" />
            <label>{formData.id > 0 ? "Actualizar" : "Guardar"}</label>
          </button>
        </div>
      </div>
    </div>
  );
};
